module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/~/core-js/library/modules/$.is-object.js
 ** module id = 87
 ** module chunks = 0
 **/